import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';
import { transformQualityData } from '@/utils/common';
export default (function (param) {
  const [quality, setQuality] = useState({});
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_PRODUCT_FORMING_ANALYSIS_QUALITY',
    method: 'GET',
  });

  useEffect(() => {
    if (param && param.params && JSON.stringify(param.params) !== '{}') {
      let url = `/api/product/forming/analysis/quality`;
      Object.keys(param.params).forEach((key, index) => {
        if (index === 0) {
          url += `?${key}=${param.params[key]}`;
        } else {
          url += `&${key}=${param.params[key]}`;
        }
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  useEffect(() => {
    if (data && JSON.stringify(data) !== '{}') {
      let new_data = transformQualityData(data, param.pageIndex, param.pageSize);
      setQuality(new_data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return [quality, isRequestSuccessed];
});
